
import {
  computed,
  defineComponent,
  ref,
  toRef,
  onMounted,
  watch,
  getCurrentInstance,
} from "vue";
import arraySort from "array-sort";

interface IPagination {
  page: number;
  total: number;
  rowsPerPage: number;
}

export interface IHeaderConfiguration {
  name?: string;
  key: string;
  sortingField?: string;
  sortable?: boolean;
}

export default defineComponent({
  name: "kt-datatable",
  emit: ["current-change", "sort", "items-per-page-change"],
  props: {
    tableHeader: {
      type: Array as () => Array<IHeaderConfiguration>,
      required: true,
    },
    tableData: { type: Array, required: true },
    emptyTableText: { type: String, default: "No data found" },
    loading: { type: Boolean, default: false },
    additionalClass: { type: String, required: false, default: '' },
    currentPage: { type: Number, default: 1 },
    enableItemsPerPageDropdown: { type: Boolean, default: true },
    total: { type: Number, default: 0 },
    rowsPerPage: { type: Number, default: 10 },
    order: { type: String, default: "asc" },
    sortLabel: { type: String, default: "" },
  },
  methods: {
    selectAll() {
      const headCheckbox = document.getElementsByName(
        "headCheckbox"
      )[0] as HTMLInputElement;
      const checkboxes = document.getElementsByName("selectCheckbox");
      checkboxes.forEach((element) => {
        (element as HTMLInputElement).checked = headCheckbox.checked;
      });
      this.$emit("checkboxSelected", headCheckbox.checked);
    },
  },
  components: {},
  setup(props, { emit }) {
    const data = toRef(props, "tableData");
    const currentSort = ref<string>("");
    const order = ref(props.order);
    const label = ref(props.sortLabel);
    const pagination = ref<IPagination>({
      page: 1,
      total: props.total,
      rowsPerPage: props.rowsPerPage,
    });

    watch(data, () => {
      pagination.value.total = props.total ? props.total : data.value.length;
    });

    onMounted(() => {
      currentSort.value = label.value + order.value;
      pagination.value.total = props.total ? props.total : data.value.length;
      pagination.value.rowsPerPage = props.rowsPerPage;
    });

    const getItems = computed(() => {
      const clone = JSON.parse(JSON.stringify(data.value));
      return clone;
    });

    const currentPageChange = (val) => {
      emit("current-change", val);
      pagination.value.page = val;
    };

    const sort = (columnName, sortable) => {
      if (sortable === false) {
        return;
      }
      if (order.value === "asc") {
        order.value = "desc";
        emit("sort", { columnName: columnName, order: "DESC" });
      } else {
        order.value = "asc";
        emit("sort", { columnName: columnName, order: "ASC" });
      }
    };

    const setItemsPerPage = (event) => {
      emit("items-per-page-change", parseInt(event.target.value));
      pagination.value.rowsPerPage = parseInt(event.target.value);
    };

    return {
      pagination,
      currentPageChange,
      getItems,
      sort,
      currentSort,
      setItemsPerPage,
    };
  },
});
